import React from 'react';
import { View } from 'react-native';
import { radius, useColors } from '../theme';
import { T } from './Text';

/** Small pill used for item counts and "n on offer" markers. */
export function CountBadge({
  value,
  tone = 'gold',
}: {
  value: string | number;
  tone?: 'gold' | 'spice' | 'muted';
}) {
  const colors = useColors();
  const bg = tone === 'gold' ? colors.gold : tone === 'spice' ? colors.spice : colors.surface2;
  const fg = tone === 'muted' ? colors.textDim : tone === 'gold' ? colors.onGold : '#FFFFFF';
  return (
    <View
      style={{
        minWidth: 22,
        paddingHorizontal: 7,
        paddingVertical: 2,
        borderRadius: radius.pill,
        backgroundColor: bg,
        borderWidth: tone === 'muted' ? 1 : 0,
        borderColor: colors.line,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <T size={11} weight={800} color={fg}>
        {value}
      </T>
    </View>
  );
}
